/**
 * Constants for the generic AttributeMapping component
 */

// Default configurations
export const DEFAULT_CONFIG = {
  maxMappings: 10,
  allowCustomValues: true,
  required: false,
};

// Common field mappings for quick setup
export const COMMON_FIELD_MAPPINGS = {
  name: ['displayName', 'fullName', 'userName'],
  email: ['emailAddress', 'email', 'mail'],
  status: ['state', 'ticketStatus', 'incidentState'],
  date: ['creationDate', 'createdOn', 'sys_created_on'],
  firstName: ['firstname', 'userObj.firstname', 'FirstName'],
  lastName: ['lastname', 'userObj.lastname', 'LastName'],
};

// Validation messages
export const VALIDATION_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  DUPLICATE_FIELD: 'Field name must be unique',
  INVALID_FIELD_NAME: 'Invalid field name format',
  MAX_MAPPINGS_REACHED: 'Maximum number of mappings reached',
};

// Component text constants
export const COMPONENT_TEXT = {
  ADD_MAPPING: 'Add Attributes',
  DELETE_MAPPING: 'Delete Mapping',
  SAVE_MAPPINGS: 'Save Mappings',
  SELECT_SAVIYNT_FIELD: 'Select Saviynt field',
  ENTER_EXTERNAL_FIELD: 'Enter external app field',
  MAPPING_COUNT: 'mappings used',
};

// CSS class names
export const CSS_CLASSES = {
  CONTAINER: 'attribute-mapping-container',
  HEADER: 'attribute-mapping-header',
  ROWS: 'attribute-mapping-rows',
  ROW: 'attribute-mapping-row',
  SAVIYNT_FIELD: 'saviynt-field',
  EXTERNAL_FIELD: 'external-app-field',
  ARROW: 'mapping-arrow',
  ACTIONS: 'attribute-mapping-actions',
  FOOTER: 'attribute-mapping-footer',
  DELETE_BUTTON: 'attribute-mapping-delete',
  MAPPING_COUNT: 'mapping-count',
};
